import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";
import { Icon } from "semantic-ui-react";
import Select, { components } from "react-select";
import { Dropdown, Popup } from "semantic-ui-react";
import moment from "moment";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
// import MoreIcon from "../../../../../../../assets/svg/more-icon.svg";
// import { ReactComponent as EditIcon } from "../../../../../../../assets/svg/edit.svg";
// import { ReactComponent as DeleteIcon } from "../../../../../../../assets/svg/delete.svg";
// import { ReactComponent as SearchIcon } from "../../../../../../../assets/svg/search.svg";
// import { ReactComponent as CaneclIcon } from "../../../../../../../assets/svg/close.svg";
import { ReactComponent as FilterImage } from "../../../../../../../assets/svg/filter.svg";
import FacebookIcon from "../../../../../../../assets/svg/facebook-icon.svg";
import InstagramIcon from "../../../../../../../assets/svg/instagram.svg";
import TwitterIcon from "../../../../../../../assets/svg/twitter-logo.svg";
import TiktokIcon from "../../../../../../../assets/svg/tiktok-icon.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import DimmerComponent from "../../../../../Dashboard/DimmerComponent";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import DeleteCompetitorModal from "../DeleteCompetitorModal/DeleteCompetitorModal";
import { Scrollbars } from "react-custom-scrollbars";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import html2canvas from "html2canvas";

import "./CompetitorInsightsTableChart.scss";
// import { deleteCompetitorAccount } from "../../../../../../../actions/competitorInsightsActions";
import { downloadCanvasWithTitle, downloadCSVData, kFormatter } from "../../../../../Dashboard/Charts/utils";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";
import { ReactComponent as InfoIcon } from "../../../../../../../assets/svg/info-icon.svg";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../../../../Dashboard/utils";

function CompetitorInsightsTableChart(props) {
    const selectedCompetitors = useSelector((state) => state.competitorInsightsReducer.selectedCompetitors);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [accountToBeDeleted, setAccountToBeDeleted] = useState("");
    const [searchText, setSearchText] = useState("");
    const [filterStatus, setFilterStatus] = useState({ text: "All", value: "" });

    const chart = useRef();

    let totalData = props.data;

    const platformFilterOptions = [
        { text: "All", value: "" },
        { text: "Facebook", value: "facebook", icon: FacebookIcon },
        { text: "Instagram", value: "instagram", icon: InstagramIcon },
        // { text: "Twitter", value: "twitter", icon: TwitterIcon },
        // { text: "TikTok", value: "tiktok", icon: TiktokIcon },
    ];

    if (props.isCompPage) {
        if (selectedCompetitors?.length > 0) {
            totalData = totalData?.filter((ac) => selectedCompetitors?.includes(ac?.research_query_id));
        }
    }

    totalData = totalData?.filter(
        (ac) => ac?.name?.toLowerCase()?.includes(searchText?.toLowerCase()) || ac?.userName?.toLowerCase()?.includes(searchText?.toLowerCase()),
    );

    if (filterStatus?.value !== "") {
        totalData = totalData?.filter((ac) => ac?.platform === filterStatus?.value);
    }

    totalData = totalData?.sort((a, b) => moment(b.modified_date) - moment(a.modified_date));

    const nodata = totalData?.length === 0 || !totalData || selectedCompetitors.length == 0;

    const platformList = {
        facebook: FacebookIcon,
        instagram: InstagramIcon,
        twitter: TwitterIcon,
        tiktok: TiktokIcon,
    };

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downLoadCSV },
                    // { name: "PNG", downloadFn: downLoadPNG, showLoader: true },
                ]}
            />
        );
    };

    const capitalizeFirstLetter = (str, locale = navigator.language) => {
        return str?.replace(/^\p{CWU}/u, (char) => char.toLocaleUpperCase(locale));
    };

    const downLoadCSV = () => {
        let chartName = "Competitor Insights Table Chart";
        let downLoadingData = [];
        downLoadingData.push([
            "No.",
            "Account Name",
            "Platform",
            "Competitor Name",
            "Posts",
            "Followers",
            "Followers' growth",
            "Engagement",
            "Reach",
            "Impression",
            "Impact",
            "Avg Impact",
            // "Impressions",
            // "Reach",
        ]);
        totalData.map((ac, ind) => {
            downLoadingData.push([
                ind + 1,
                String(ac?.userName) || "0",
                capitalizeFirstLetter(ac?.platform) || "0",
                ac?.name || "0",
                ac?.posts === 0 ? ac?.posts : ac?.posts || "0",
                ac?.followersCount === 0 ? ac?.followersCount : ac?.followersCount || "0",
                ac?.followersGrowth === 0 ? ac?.followersGrowth : ac?.followersGrowth || "0",
                ac?.totalEngagement || 0,
                ac?.reach || 0,
                ac?.impression || 0,
                ac?.engagement === 0 ? ac?.engagement : ac?.engagement || "0",
                ac?.posts ? (ac?.engagement / ac.posts).toFixed(2) : 0,
                // ac?.impressions === 0 ? ac?.impressions : ac?.impressions || "0",
                // ac?.reach === 0 ? ac?.reach : ac?.reach || "0",
            ]);
        });
        downloadCSVData(downLoadingData, props.widget?.name || chartName);
    };
    const downLoadPNG = (cb) => {
        if (chart?.current)
            return html2canvas(chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();
                    downloadCanvasWithTitle(canvas, props.widget?.name || "Competitor Insights Table Chart");
                },
            );
    };

    const myStyleForSelect = {
        control: (base) => ({
            ...base,
            border: 0,
            boxShadow: "none",
            background: "#E7E8F0",
            height: "36px",
            minHeight: "36px",
            cursor: "pointer",
            // width: "120px",
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: isFocused ? (isSelected ? "#268af6" : "#f2f3ff") : isSelected ? "#268af6" : null,
                color: isSelected ? "white" : "#1F2E3D",
                cursor: "pointer",
                width: "120px",
            };
        },
        menu: (provided) => ({
            ...provided,
            zIndex: 999999,
            width: "120px",
        }),
        valueContainer: (base) => ({ ...base }),
    };
    const Control = ({ children, ...props }) => {
        const style = { cursor: "pointer" };
        return (
            <components.Control {...props}>
                <span style={style}>{!!children && <FilterImage style={{ height: "20px", width: "20px" }} />}</span>
                <span className="zzzfb">{children}</span>
            </components.Control>
        );
    };

    const truncate = (str = "", max = 14) => {
        const ellipsis = str?.length > max ? "..." : "";
        return str?.slice(0, max) + ellipsis;
    };
    const tableChartHeading = [
        {
            content: "Account Name",
            className: "username",
            popupContent: "This is the page or account name that you have configured.",
        },
        {
            content: "Platform",
            className: "platform",
            popupContent: "This is the platform of the account that you have configured.",
        },
        {
            content: "Competitor Name",
            className: "displayName",
            popupContent: "This is the name of your competitors as configured by you.",
        },
        {
            content: "Posts",
            className: "posts",
            popupContent: "This shows the total number of posts made by your competitor during the time period selected in the filters.",
        },
        {
            content: "Followers",
            className: "followers",
            popupContent: "This shows the total number of followers the account has as of now.",
        },
        {
            content: "Followers' growth",
            className: "followersGrowth",
            popupContent:
                "This shows the follower growth compared to the beginning of the period. The period can be changed using the filters. You can chose 7 days, 30 days or a custom period.",
        },
        {
            content: "Engagement",
            className: "engagement",
            popupContent:
                "This shows the total engagement created by all posts posted in the selected time period. Engagement value is the sum of likes, comments and shares of the posts.",
        },
        {
            content: "Reach",
            className: "engagement",
            popupContent: "This shows the total reach of all the posts posted in the selected time period.",
        },
        {
            content: "Impression",
            className: "engagement",
            popupContent: "This shows the total views of all the posts posted in the selected time period.",
        },

        {
            content: "Impact",
            className: "engagement",
            popupContent:
                "This shows the total impact created by all posts posted in the selected time period. Impact is a proprietary algorithm created by Radarr and uses a weighted average of likes, shares, comments, views to display a common metric that can be used to compare different social profiles.",
        },
        {
            content: "Avg Impact",
            className: "engagement",
            popupContent: "This shows the average impact per posts.  This is simply the total Impact divided by the number of posts.",
        },
    ];

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    name={props.widget?.name || "Competitor Insights Table Chart"}
                    info="This chart shows you information about your competitor pages that you have configured. This chart can be used to monitor your competitor's activity and campaigns and the impact their “owned media”  is creating."
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isCompPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget?.name}
                            />
                        )}

                    {!props.isPublic && !props.isResearchDashboard && !nodata && renderDownloadButton(nodata)}

                    {(props.isPublic && nodata) || props.isCompPage ? null : (
                        <Popup
                            className="skiptranslate"
                            trigger={
                                props.expandWidget ? (
                                    <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                ) : (
                                    <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                )
                            }
                            inverted
                            content={props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                            size="mini"
                            position="bottom center"
                            style={{ zIndex: "99999" }}
                        />
                    )}
                    {!props.isCompPage && !props.isPublic && <MoreOptions className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />}
                </div>
            </div>
            {!props.isCompPage && props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {!props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                            </>
                        )}
                    {!props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && <DeleteWidget onClick={props.deleteWidget} />}
                </ChartOptionsSidebar>
            )}

            <div className="dashboard-chart skiptranslate" ref={chart}>
                {/* <div className="searchSection">
                    <div className="competitorInsights__search">
                        <span>
                            <SearchIcon />
                        </span>
                        <input type="text" placeholder="Search" onChange={(e) => setSearchText(e.target.value)} value={searchText} />
                        {searchText && (
                            <span className="cancel__wrap">
                                <span className="cancel-search" onClick={() => setSearchText("")}>
                                    <CaneclIcon />
                                </span>
                            </span>
                        )}
                    </div>
                    <div className="right-filter-section" data-html2canvas-ignore="true">
                        <Select
                            options={platformFilterOptions}
                            className="fbpost-location"
                            placeholder="Filter"
                            value={filterStatus}
                            onChange={(val) => setFilterStatus(val)}
                            styles={myStyleForSelect}
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ValueContainer: Control }}
                            isSearchable={false}
                            getOptionLabel={(e) => {
                                if (e.text !== "All")
                                    return (
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <img style={{ height: "20px", width: "20px", objectFit: "contain" }} src={e.icon} />
                                            <span style={{ marginLeft: 7 }}>{e.text}</span>
                                        </div>
                                    );
                                else
                                    return (
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <span style={{ marginLeft: 7 }}>{e.text}</span>
                                        </div>
                                    );
                            }}
                        />
                    </div>
                </div> */}
                {!nodata && !props.loading && !props.ruleCreatorLoading && !props.joiningAccount ? (
                    <div className="competitorInsightsTableChart">
                        <Scrollbars autoHide>
                            <div className="tableHeader header">
                                {/* <div className="serialNo">No.</div>
                                <div className="username">Account Name</div>
                                <div className="platform">Platform</div>
                                <div className="displayName">Competitor Name</div>
                                <div className="posts">Posts</div>
                                <div className="followers">Followers</div>
                                <div className="followersGrowth">Followers&apos; growth</div>
                                <div className="engagement">Impact</div>
                                <div className="engagement">Avg Impact</div> */}

                                {/* <div className="engagement">Impressions</div>
                                <div className="engagement">Reach</div> */}
                                <div className="serialNo " style={{ paddingRight: "5px" }}>
                                    No.
                                </div>

                                {tableChartHeading.map((ele, idx) => (
                                    <div key={idx} className={`${ele.className}  ${ele.content} table__heading`}>
                                        <span>{ele.content}</span>
                                        <Popup
                                            key={idx}
                                            className="skiptranslate"
                                            position={idx + 1 === tableChartHeading.length ? "top left" : "top center"}
                                            size="mini"
                                            inverted
                                            content={ele.popupContent}
                                            trigger={<InfoIcon />}
                                            style={{ zIndex: "99999" }}
                                        />
                                    </div>
                                ))}
                                {/* {!props.isPublic ? (
                                    <div data-html2canvas-ignore="true" className="delete">
                                        More
                                    </div>
                                ) : null} */}
                            </div>

                            {/* <Scrollbars autohide> */}
                            <div className="tableBody">
                                {totalData?.map((ac, index) => (
                                    <div key={index} className="tableRow">
                                        <div className="serialNo">{index + 1}</div>
                                        <div className="username">
                                            <Popup
                                                className="skiptranslate"
                                                position="top left"
                                                size="mini"
                                                inverted
                                                content={ac?.userName}
                                                trigger={<span>{truncate(ac?.userName)}</span>}
                                                style={{ zIndex: "99999" }}
                                            />
                                        </div>

                                        <div className="platform">
                                            <img className="platformIcon" src={platformList[ac?.platform]} alt="" />
                                        </div>
                                        <div className="displayName">
                                            <Popup
                                                className="skiptranslate"
                                                position="top left"
                                                size="mini"
                                                inverted
                                                content={ac?.name}
                                                trigger={<span>{truncate(ac?.name)}</span>}
                                                style={{ zIndex: "99999" }}
                                            />
                                        </div>

                                        <div className="posts">
                                            <Popup
                                                className="skiptranslate"
                                                position="top left"
                                                size="mini"
                                                inverted
                                                content={numberWithCommas(ac?.posts)}
                                                trigger={<span>{kFormatter(ac?.posts)}</span>}
                                                style={{ zIndex: "99999" }}
                                            />
                                        </div>
                                        <div className="followers">
                                            <Popup
                                                className="skiptranslate"
                                                position="top left"
                                                size="mini"
                                                inverted
                                                content={numberWithCommas(ac?.followersCount || 0)}
                                                trigger={<span>{kFormatter(ac?.followersCount) || "0"}</span>}
                                                style={{ zIndex: "99999" }}
                                            />
                                        </div>
                                        <div className="followersGrowth">
                                            {ac?.followersGrowth || ac?.followersGrowth === 0 ? (
                                                <>
                                                    <p>
                                                        {ac?.followersGrowth > 0 ? (
                                                            <Icon name="arrow up" color="green" />
                                                        ) : ac?.followersGrowth < 0 ? (
                                                            <Icon name="arrow down" color="red" />
                                                        ) : null}
                                                    </p>

                                                    <Popup
                                                        className="skiptranslate"
                                                        position="top left"
                                                        size="mini"
                                                        inverted
                                                        content={numberWithCommas(ac?.followersGrowth || 0)}
                                                        trigger={<span>{kFormatter(ac?.followersGrowth || 0)}</span>}
                                                        style={{ zIndex: "99999" }}
                                                    />

                                                    {/* <p>{</p> */}
                                                </>
                                            ) : (
                                                "0"
                                            )}
                                        </div>
                                        <div className="engagement">
                                            <Popup
                                                className="skiptranslate"
                                                position="top left"
                                                size="mini"
                                                inverted
                                                content={numberWithCommas(ac?.totalEngagement || 0)}
                                                trigger={<span>{kFormatter(ac?.totalEngagement)}</span>}
                                                style={{ zIndex: "99999" }}
                                            />
                                        </div>
                                        <div className="engagement">
                                            <Popup
                                                className="skiptranslate"
                                                position="top left"
                                                size="mini"
                                                inverted
                                                content={numberWithCommas(ac?.reach || 0)}
                                                trigger={<span>{kFormatter(ac?.reach)}</span>}
                                                style={{ zIndex: "99999" }}
                                            />
                                        </div>
                                        <div className="engagement">
                                            <Popup
                                                className="skiptranslate"
                                                position="top left"
                                                size="mini"
                                                inverted
                                                content={ac?.platform === "instagram" ? "NA" : numberWithCommas(ac?.impression || 0)}
                                                trigger={<span>{ac?.platform === "instagram" ? "NA" : kFormatter(ac?.impression || 0)}</span>}
                                                style={{ zIndex: "99999" }}
                                            />
                                        </div>
                                        <div className="engagement">
                                            <Popup
                                                className="skiptranslate"
                                                position="top left"
                                                size="mini"
                                                inverted
                                                content={numberWithCommas(ac?.engagement || 0)}
                                                trigger={<span>{kFormatter(ac?.engagement)}</span>}
                                                style={{ zIndex: "99999" }}
                                            />
                                        </div>
                                        <div className="engagement">
                                            <Popup
                                                className="skiptranslate"
                                                position="top left"
                                                size="mini"
                                                inverted
                                                content={ac?.posts || ac?.posts !== 0 ? numberWithCommas((ac?.engagement / ac?.posts).toFixed(2)) : "0"}
                                                trigger={<span> {kFormatter(ac?.posts ? (ac?.engagement / ac.posts).toFixed(2) : 0)}</span>}
                                                style={{ zIndex: "99999" }}
                                            />
                                        </div>
                                        {/* <Popup
                                            className="skiptranslate"
                                            position="top left"
                                            size="mini"
                                            inverted
                                            content={ac?.impressions || ac?.impressions === 0 ? ac?.impressions : "0"}
                                            trigger={<div className="engagement">{kFormatter(ac?.impressions)}</div>}
                                            style={{ zIndex: "99999" }}
                                        />
                                        <Popup
                                            className="skiptranslate"
                                            position="top left"
                                            size="mini"
                                            inverted
                                            content={ac?.reach || ac?.reach === 0 ? ac?.reach : "0"}
                                            trigger={<div className="engagement">{kFormatter(ac?.reach)}</div>}
                                            style={{ zIndex: "99999" }}
                                        /> */}

                                        {/* {!props?.isPublic && (
                                            <div className="delete" data-html2canvas-ignore="true">
                                                <Popup
                                                    trigger={
                                                        <img
                                                            className="moreImage"
                                                            src={MoreIcon}
                                                            title="Actions"
                                                            // style={{ height: "16px", width: "16px", color: "black", cursor: "pointer" }}
                                                        />
                                                    }
                                                    content={
                                                        <div className="modal-wrap">
                                                            {props.isCompPage ? (
                                                                <div
                                                                    className="modal-row"
                                                                    onClick={() => props.setEditCompetitor(ac)}
                                                                    style={{ cursor: "pointer" }}
                                                                    title="Click to edit competitor">
                                                                    <EditIcon style={{ height: "14px", width: "14px", marginRight: "4px" }} />
                                                                    Edit
                                                                </div>
                                                            ) : (
                                                                <Link
                                                                    to="/owned-page/competitor"
                                                                    className="modal-row"
                                                                    style={{ cursor: "pointer", color: "#1f2e3d" }}
                                                                    title="Click to edit competitor">
                                                                    <EditIcon style={{ height: "14px", width: "14px", marginRight: "4px" }} />
                                                                    Edit
                                                                </Link>
                                                            )}

                                                            {props.isCompPage ? (
                                                                <div
                                                                    className="modal-row"
                                                                    onClick={() => {
                                                                        setIsDeleteModalOpen(true);
                                                                        setAccountToBeDeleted(ac);
                                                                    }}
                                                                    style={{ cursor: "pointer" }}
                                                                    title="Click to delete topic">
                                                                    <DeleteIcon style={{ height: "14px", width: "14px", marginRight: "4px" }} />
                                                                    Delete
                                                                </div>
                                                            ) : (
                                                                <Link to="/owned-page/competitor">
                                                                    <div
                                                                        className="modal-row"
                                                                        style={{ cursor: "pointer", color: "#1f2e3d" }}
                                                                        title="Click to delete topic">
                                                                        <DeleteIcon style={{ height: "14px", width: "14px", marginRight: "4px" }} />
                                                                        Delete
                                                                    </div>
                                                                </Link>
                                                            )}
                                                        </div>
                                                    }
                                                    on="click"
                                                    size="small"
                                                    position="right center"
                                                />
                                            </div>
                                        )} */}
                                    </div>
                                ))}
                            </div>
                        </Scrollbars>

                        <DeleteCompetitorModal
                            open={isDeleteModalOpen}
                            onClose={() => setIsDeleteModalOpen(false)}
                            deleteCompetitorAccount={props.deleteCompetitorAccount}
                            account={accountToBeDeleted}
                        />
                    </div>
                ) : props.loading || props.ruleCreatorLoading || props.joiningAccount ? (
                    <DimmerComponent />
                ) : (
                    <NoData />
                )}
            </div>
        </>
    );

    return props.isCompPage ? <div className={`dashboard-widget-container ${props.expandWidget ? "maximize-widget" : ""}`}>{elements}</div> : <>{elements}</>;
}

export default CompetitorInsightsTableChart;
